import { ScreenLockerLoad } from '@components/ScreenLockerLoad'
import React, { useCallback, useMemo, useState, ReactNode } from 'react'

interface ILockParams {
  title: string
  description: string
}
interface IProviderProps {
  lock: ({ title, description }: ILockParams) => void
  unlock: () => void
}

export const SLLContext = React.createContext<IProviderProps>(
  {} as IProviderProps,
)

export function SSLProvider({ children }: { children: ReactNode }) {
  const [sslIsOpen, setSslIsOpen] = useState(false)
  const [[title, description], setTitleAndDescription] = useState(['', ''])

  const lock = useCallback(({ title, description }: ILockParams) => {
    setSslIsOpen(true)
    setTitleAndDescription([title, description])
  }, [])

  const unlock = useCallback(() => {
    setSslIsOpen(false)
    setTitleAndDescription(['', ''])
  }, [])

  const contextValue = useMemo(() => ({ lock, unlock }), [lock, unlock])

  return (
    <SLLContext.Provider value={contextValue}>
      {children}
      <ScreenLockerLoad
        visible={sslIsOpen}
        title={title}
        description={description}
      />
    </SLLContext.Provider>
  )
}
